export const finalQuizData = [
    // {
    //     question: 'Quelle est la bactérie responsable de la coqueluche ?',
    //     options: ['Bordetella pertussis', 'Streptococcus pneumoniae', 'Haemophilus influenzae'],
    //     answer: 'Bordetella pertussis',
    //     debriefCorrect: 'Super, nos recherches concordent !',
    //     illustrationQuestion: 'histoire-1/quiz-final/q',
    //     illustrationDebrief: 'histoire-1/quiz-final/r',
    //     debrief:
    //         "La coqueluche est causée par la bactérie Bordetella pertussis, un bacille qui s'installe dans les voies respiratoires et provoque une toux intense et persistante.",
    // },
    {
        question: "Que signifie l'acronyme Hib\u00A0?",
        options: [
            'Haemophilus influenzae de type B',
            'Haemophilus intestinalis bactérien',
            'Helicobacter influenzae bronchique',
        ],
        answer: 'Haemophilus influenzae de type B',
        debriefCorrect: "Nous sommes d'accord !",
        illustrationQuestion: 'histoire-1/quiz-final/q',
        illustrationDebrief: 'histoire-1/quiz-final/r',
        debrief:
            'Le Hib, pour Haemophilus influenzae de type B, est une bactérie qui peut provoquer de graves infections chez les jeunes enfants\u00A0: méningites ou infections respiratoires par exemple !',
    },
    // {
    //     question: 'Quel facteur peut expliquer la résurgence de la coqueluche ?',
    //     options: [
    //         "La baisse d'immunité des bébés",
    //         'La mutation de la bactérie',
    //         'Le calendrier vaccinal',
    //     ],
    //     answer: 'La mutation de la bactérie',
    //     debriefCorrect: 'Je suis du même avis !',
    //     illustrationQuestion: 'histoire-1/quiz-final/q',
    //     illustrationDebrief: 'histoire-1/quiz-final/r',
    //     debrief:
    //         "Les analyses ont révélé que bordetella pertussis évolue : au fil du temps, la bactérie modifie certaines de ses structures pour mieux se propager et contourner les défenses de l'organisme.",
    // },
    {
        question: 'Les vaccins hexavalents commercialisés sont strictement identiques.',
        options: ['Vrai', 'Faux'],
        answer: 'Faux',
        debriefCorrect: 'Parfait !',
        illustrationQuestion: 'histoire-1/quiz-final/q',
        illustrationDebrief: 'histoire-1/quiz-final/r-finale',
        debrief: 'Bien que tous recommandés par la HAS, la composition des vaccins varie.',
    },
    {
        question:
            'Quelles protéines peuvent être utilisées pour la conjugaison de la valence Hib ?',
        options: [
            'Les protéines tétaniques et méningococciques',
            'Les protéines coquelucheuses et diphtériques',
            'Les protéines virales et hépatiques',
        ],
        answer: 'Les protéines tétaniques et méningococciques',
        debriefCorrect: "Je suis d'accord avec toi !",
        illustrationQuestion: 'histoire-1/quiz-final/q',
        illustrationDebrief: 'histoire-1/quiz-final/r',
        debrief:
            'Pour que le système immunitaire des nourrissons reconnaisse le Hib, on associe le sucre de la bactérie à une protéine porteuse : tétanique ou méningococcique.',
        finalText:
            'Eh bien Maïté, on dirait qu\'on est arrivés aux mêmes conclusions.<br /><br /><span class="bold">Encore une mission rondement menée !</span>',
    },
];
